import { BooleanField } from 'react-admin';

import {
    Datagrid,
    List,
    TextField
} from 'react-admin';

export const SurveyQuestionList = () => (
	<List>
		<Datagrid rowClick="edit">
			<BooleanField source="visible" />
			<TextField source="question.he" />

			<TextField source="slug" />
			<TextField source="type" />
		</Datagrid>
	</List>
);
export default SurveyQuestionList;
